import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


function pathViewWebhookShforms(webhookId=null) {
  if (webhookId) {
      return `view/webhook-shforms/${webhookId}`;
  } else {
      return `view/webhook-shforms`;
  }
}

export function getViewWebhookShforms(successCallback, errorCallback, webhookId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewWebhookShforms(webhookId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageWebhooks(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-webhooks`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathWebhooks(webhookId=null) {
  if (webhookId) {
      return `webhooks/${webhookId}`;
  } else {
      return `webhooks`;
  }
}

export function createWebhooks(successCallback, errorCallback, data) {
  postAuth({
    "path": pathWebhooks(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchWebhooks(successCallback, errorCallback, data, webhookId) {
  patchAuth({
    "path": pathWebhooks(webhookId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteWebhooks(successCallback, errorCallback, webhookId) {
  deleteAuth({
    "path": pathWebhooks(webhookId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function testWebhooks(successCallback, errorCallback, data, webhookId) {
  postAuth({
    "path": `webhooks/${webhookId}/test`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}









